/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InstallationType,
    InstallationTypeFromJSON,
    InstallationTypeFromJSONTyped,
    InstallationTypeToJSON,
    UnavailableFeature,
    UnavailableFeatureFromJSON,
    UnavailableFeatureFromJSONTyped,
    UnavailableFeatureToJSON,
} from './';

/**
 * 
 * @export
 * @interface InstallationInfo
 */
export interface InstallationInfo {
    /**
     * 
     * @type {number}
     * @memberof InstallationInfo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InstallationInfo
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationInfo
     */
    avatarUrl: string;
    /**
     * 
     * @type {number}
     * @memberof InstallationInfo
     */
    repoCount: number;
    /**
     * 
     * @type {InstallationType}
     * @memberof InstallationInfo
     */
    type: InstallationType;
    /**
     * 
     * @type {Array<UnavailableFeature>}
     * @memberof InstallationInfo
     */
    unavailableFeatures: Array<UnavailableFeature>;
}

export function InstallationInfoFromJSON(json: any): InstallationInfo {
    return InstallationInfoFromJSONTyped(json, false);
}

export function InstallationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'login': json['login'],
        'avatarUrl': json['avatarUrl'],
        'repoCount': json['repoCount'],
        'type': InstallationTypeFromJSON(json['type']),
        'unavailableFeatures': ((json['unavailableFeatures'] as Array<any>).map(UnavailableFeatureFromJSON)),
    };
}

export function InstallationInfoToJSON(value?: InstallationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'login': value.login,
        'avatarUrl': value.avatarUrl,
        'repoCount': value.repoCount,
        'type': InstallationTypeToJSON(value.type),
        'unavailableFeatures': ((value.unavailableFeatures as Array<any>).map(UnavailableFeatureToJSON)),
    };
}

